<template>
  <div class="testimonial-wrap">
    <v-container>
      <div class="section-header text-center mb-10">
        <div class="section-kicker-bar mb-3">
          <v-chip small outlined color="primary" class="kicker-chip">
            <v-icon small left>mdi-star-outline</v-icon>
            {{ $t('header.testimonials') }}
          </v-chip>
        </div>
        <h3 class="display-2 title-style">
          {{ $t("header.testimonials") }}
        </h3>
      </div>

      <div class="carousel" v-if="loaded" dir="rtl">
        <slick ref="slick" :options="slickOptions">
          <div v-for="(item, index) in testiContent" :key="index" class="item">
            <testi-card :text="item.text" :avatar="item.avatar ?? ''" :name="item.name" :rating="item.rating" />
          </div>
        </slick>
      </div>
    </v-container>
  </div>
</template>

<style scoped lang="scss">
@import './testimonials-style';
</style>

<script>
import TestiCard from '../Cards/TestiCard'

export default {
  components: {
    Slick: () => import('vue-slick'),
    TestiCard
  },
  data() {
    return {
      loaded: false,
      testiContent: [
        {
          text: 'متنامي اسم على مسمى، جودة في التنفيذ واحترافية في التعامل.',
          name: 'محمد إمام',
          role: 'رائد أعمال',
          rating: 5,
        },
        {
          text: 'فرق شاسع بين تطبيقاتنا السابقة وتطبيق متنامي من حيث الجودة، التقنيات المستخدمة، سرعة التواصل، والاستشارات القيمة.',
          name: 'عميل متميز',
          role: 'مدير تنفيذي',
          rating: 5,
        },
        {
          text: 'فكرة جديدة وخارج الصندوق، ساعدتني كثيراً في تطوير وتسهيل آليات عملي.',
          name: 'علي خالد',
          role: 'صاحب مشروع رقمي',
          rating: 5,
        },
        {
          text: 'عمل متقن وخدمة احترافية، بارك الله في جهودكم ونفع بكم.',
          name: 'أحمد ناصر',
          role: 'شريك استراتيجي',
          rating: 5,
        },
        {
          text: 'من أروع وأرقى المنصات التي تعاملت معها، دقة في المواعيد وسلاسة في النظام.',
          name: 'أسامة رجب',
          role: 'مطور أعمال',
          rating: 5,
        },
        {
          text: 'برنامج رائع ومتكامل، وتجربة الدعم الفني لديهم أكثر من رائعة واستجابتهم فورية.',
          name: 'محمد عادل',
          role: 'مدير عمليات',
          rating: 5,
        }
      ],
      slickOptions: {
        dots: true,
        arrows: false,
        slidesToShow: 3,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 5000,
        speed: 800,
        cssEase: 'cubic-bezier(0.4, 0, 0.2, 1)',
        responsive: [
          {
            breakpoint: 800,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
      }
    }
  },
  mounted() {
    this.loaded = true
  }
}
</script>
